var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterCafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77839e-06 19.7925H42.5C44.4891 19.7925 46.3968 20.5876 47.8033 22.0029C49.2098 23.4182 50 25.3378 50 27.3393C50 29.3409 49.2098 31.2604 47.8033 32.6758C46.3968 34.0911 44.4891 34.8862 42.5 34.8862H39.37C38.157 39.6335 35.2638 43.7722 31.2334 46.5254C27.2031 49.2786 22.3127 50.457 17.4802 49.8394C12.6477 49.2218 8.20533 46.8508 4.98688 43.1712C1.76843 39.4917 -0.00480478 34.7567 9.77839e-06 29.8549V19.7925ZM40 29.8549H42.5C43.163 29.8549 43.7989 29.5899 44.2678 29.1181C44.7366 28.6464 45 28.0065 45 27.3393C45 26.6721 44.7366 26.0323 44.2678 25.5605C43.7989 25.0888 43.163 24.8237 42.5 24.8237H40V29.8549Z",
    fill: "#DC4200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 0.398C25.6667 -0.833191 9 0.0814083 9 13.5893H22.8889C31.7778 13.5893 34 0.398 34 0.398Z",
    fill: "#DC4200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterCafe);
export default __webpack_public_path__ + "static/media/footer_cafe.bdc96979ac4a3996b7d243857b2cc82c.svg";
export { ForwardRef as ReactComponent };